import React from 'react';
 

//                <td><a href="" target="_blank" className="links" ><button>Click Aca</button></a></td>

const PrimeroSegundo = () => {
    return (
        <div className='seccion'>		
        
			<h1>PROGRAMAS DE ESTUDIOS - 2025</h1>

            <h4>Materias Plan Institucional - 1er y 2do año</h4>	
        
        <div className="contenedor-tablas">
        <table className="tabla-programas">
            <caption>1er Año</caption>
            <tr>

                <th>Areas</th>
                <th>Espacio Curricular</th>
                <th>Programa</th>

            </tr>
            <tr>
                <td>Ciencias Naturales</td>
                <td>Fco Quimica <br/> Biologia</td>
                <td><a href="https://drive.google.com/drive/folders/16f4Fopno96QaDCrrEZUK-aH5rspuOkY1?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>
            </tr>
            <tr>
                <td>Lengua y Produccion Artistica</td>
                <td>Lengua <br/> Literatura <br/> Ingles <br/> Artes Visuales <br/> Musica <br/> Teatro </td>
                <td><a href="https://drive.google.com/drive/folders/1RWktfQKmN_nU5jpRj0E3k0K585UUM3r4?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>
            </tr>
            <tr>
                <td>Matematica - Informatica</td>
                <td>Matematica <br/> Informatica</td>
                <td><a href="https://drive.google.com/drive/folders/104nXk_V7GOj6ojE2YojP3aRXWh15QQg6?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>
            </tr>
            <tr>
                <td>Ciencas Sociales Politicas y Economicas</td>
                <td>Historia <br/> Construccion Ciudadana <br/> Geografia <br/> Economia <br/> Filosofia</td>
                <td><a href="https://drive.google.com/drive/folders/1kUGOog9CGgK9srF3rP5lz7CwWzL2iYoL?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>
            </tr>
            <tr>
                <td>Educacion Sexual Integral (ESI)</td>
                <td>ESI</td>
                <td><a href="https://drive.google.com/drive/folders/1MPze1jC3pGzb8KF8-anSEC2qV29skbZB?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>
            </tr>
            <tr>
                <td>Integracion Tecnologica (int. Tec.)</td>
                <td>Int. Tec.</td>
                <td><a href="https://drive.google.com/drive/folders/1J51jYA5Ra0LbNbLJkUv_O8_UVAJxEjlv?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>
            </tr>
            <tr>
                <td>Educacion Fisica Integral (EFI)</td>
                <td>EFI</td>
                <td><a href="https://drive.google.com/drive/folders/1BA_pHZzd4QRiLeb5MWVACFf-cvgqeqsi?usp=drive_link" target="_blank" className="links" ><button>Click Aca</button></a></td>
            </tr>

        </table>
        <table className="tabla-programas">
            <caption>2do Año</caption>
            <tr>

                <th>Areas</th>
                <th>Espacio Curricular</th>
                <th>Programa</th>

            </tr>
            <tr>
                <td>Ciencias Naturales</td>
                <td>Fco Quimica <br/> Biologia</td>
                <td><a href="" target="_blank" className="links" ><button>Click Aca</button></a></td>
            </tr>
            <tr>
                <td>Lengua y Produccion Artistica</td>
                <td>Lengua <br/> Literatura <br/> Ingles <br/> Artes Visuales <br/> Musica <br/> Teatro </td>
                <td><a href="" target="_blank" className="links" ><button>Click Aca</button></a></td>
            </tr>
            <tr>
                <td>Matematica</td>
                <td>Matematica <br/> Informatica</td>
                <td><a href="" target="_blank" className="links" ><button>Click Aca</button></a></td>
            </tr>
            <tr>
                <td>Ciencas Sociales Politicas y Economicas</td>
                <td>Historia <br/> Construccion Ciudadana <br/> Geografia <br/> Economia <br/> Filosofia</td>
                <td><a href="" target="_blank" className="links" ><button>Click Aca</button></a></td>
            </tr>
            <tr>
                <td>Educacion Sexual Integral (ESI)</td>
                <td>ESI</td>
                <td><a href="" target="_blank" className="links" ><button>Click Aca</button></a></td>
            </tr>
            <tr>
                <td>Integracion Tecnologica (int. Tec.)</td>
                <td>Int. Tec.</td>
                <td><a href="" target="_blank" className="links" ><button>Click Aca</button></a></td>
            </tr>
            <tr>
                <td>Educacion Fisica Integral (EFI)</td>
                <td>EFI</td>
                <td><a href="" target="_blank" className="links" ><button>Click Aca</button></a></td>
            </tr>
            
            
        </table>
    </div>
            
        </div>
    );
}

export default PrimeroSegundo;
